import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BordroComponent } from './user/bordro/bordro.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HesapComponent } from './user/hesap/hesap.component';
import { LoginComponent } from './login/login.component';
import { Page404Component } from './page404/page404.component';
import { PuantajComponent } from './user/puantaj/puantaj.component';
import { SifreDegistirComponent } from './user/sifre-degistir/sifre-degistir.component';
import { PdfYukleComponent } from './admin/pdf-yukle/pdf-yukle.component';
import { KullaniciPaneliComponent } from './admin/kullanici-paneli/kullanici-paneli.component';
import { AuthGuard } from './helper/auth.guard';
import { MessagesComponent } from './messages/messages.component';





const routes: Routes = [
  {path: '' , component: LoginComponent},
  //{ path: 'dashboard', redirectTo: "/dashboard", pathMatch: "full" },
  {path: 'dashboard' , component: DashboardComponent, canActivate: [AuthGuard],
  
    children: [
      {
        path: 'bordro', // child route path
        component: BordroComponent, // child route component that the router renders
      },
      {
        path: 'puantaj',
        component: PuantajComponent, // another child route component that the router renders
      },
      {
        path: 'hesap',
        component: HesapComponent, // another child route component that the router renders
      },
      {
        path: 'mesajlar',
        component: MessagesComponent, // another child route component that the router renders
      },
      {
        path: 'sifreDegistir',
        component: SifreDegistirComponent, // another child route component that the router renders
      },
      {
        path: 'kullaniciPaneli',
        component: KullaniciPaneliComponent, // another child route component that the router renders
      },
      {
        path: 'pdfYukle',
        component: PdfYukleComponent, // another child route component that the router renders
      },
    ],

  },
  {path: '**' , component: Page404Component},
];



@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }